import React from 'react';
import type { BlockColumnList } from 'types/block-column-list';

import { Wrap, Paragraph } from '@leafwell/components';

import Figure from './figure';
import HeadingBody from './heading-body';

const ColumnList: React.FC<BlockColumnList> = ({
  title,
  description,
  list,
}) => (
  <Wrap size="large" className="md:grid-cols-2 md:gap-x-28 gap-y-14">
    {(title || description) && (
      <div className="col-span-full flex flex-col items-center pb-10">
        {title && (
          <HeadingBody
            {...{
              className: 'col-span-full text-center font-semibold',
              level: '2',
              tagName: 'h3',
              title,
            }}
          />
        )}
        {description && (
          <Paragraph variant="medium" className="max-w-xl py-6">
            {description}
          </Paragraph>
        )}
      </div>
    )}
    {list.map(({ title, description, icon }) => {
      return (
        <article className="flex">
          <Figure {...icon} className="w-16 bg-white z-10" />
          <div className="pl-10 flex-1">
            <HeadingBody level="4" title={title} className="font-semibold" />
            <Paragraph className="pt-3">{description}</Paragraph>
          </div>
        </article>
      );
    })}
  </Wrap>
);

export default ColumnList;
